<template>
  <Layout :title="title">
    <Title
      icon="account"
      heading="Your Account"
      sub-heading="Manage your account settings and more."
    />

    <div class="container">
      <div class="row">
        <div class="col">
          <h2 class="mt-5">Account Settings (Administration)</h2>
        </div>
      </div>
    </div>

    <div class="container my-5">
      <div class="row">
        <div class="col">
          <nav class="nav nav-tabs nav-fill">
            <inertia-link
              class="nav-item nav-link "
              :class="{ active: route().current('organisation.show') }"
              :href="
                route('organisation.show', $page.props.auth.user.organisation.id)
              "
              >Manage Account</inertia-link
            >
            <inertia-link
              class="nav-item nav-link "
              :class="{ active: route().current('organisation.user.index') }"
              :href="
                route(
                  'organisation.user.index',
                  $page.props.auth.user.organisation.id
                )
              "
              >Manage Users</inertia-link
            >
          </nav>
        </div>
      </div>
    </div>

    <slot />
  </Layout>
</template>

<script>
import Layout from '@/Shared/Layout';
import Title from '@/Shared/Title';

export default {
  components: {
    Title,
    Layout,
  },

  props: {
    title: String,
  },

  watch: {
    title: {
      immediate: true,
      handler(title) {
        document.title = title ? `${title} | Claus.ify` : 'Claus.ify';
      },
    },
  },
};
</script>
